import React from 'react';
import './MoodSnapshot.css';
import logComponent from '../../common/logComponent';
import MoodSnapshot from './MoodSnapshot';
import { CardMoodSnapshotProvider } from '../../contexts/CardMoodSnapshotContext';
 
export default function MoodSnapshotCard({ moduleDescription }) {
  if (logComponent('MoodSnapshotCard')) { console.debug('MoodSnapshotCard rendered'); }


  return (
    <CardMoodSnapshotProvider>
      <MoodSnapshot moduleDescription={moduleDescription} />
    </CardMoodSnapshotProvider>
  );
}